import React from "react";
import { useIntl } from "react-intl";
import { PeekButton } from "@piiqtechnologies/ui-components";
import messages from "../messages.i18n";
export const NewReportNextButton = ({ label, disabled = false, onClick }) => {
    const intl = useIntl();
    return (React.createElement(PeekButton, { variant: "contained", color: "primary", size: "large", disabled: disabled, onClick: onClick, sx: { minWidth: 400, py: 1.5 } }, label !== null && label !== void 0 ? label : intl.formatMessage(messages.newReportLayoutNext)));
};
export default NewReportNextButton;
